import { render, staticRenderFns } from "./service_support.vue?vue&type=template&id=7ff629b6&scoped=true"
import script from "./service_support.vue?vue&type=script&lang=js"
export * from "./service_support.vue?vue&type=script&lang=js"
import style0 from "./service_support.vue?vue&type=style&index=0&id=7ff629b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff629b6",
  null
  
)

export default component.exports